import Layout from '../../../Layout';
import Photos from './photos';

import * as S from './styles';
import useScrollToTop from '../../../../utils/useScrollToTop';

function DefinitionOfSupportedProjects() {
  useScrollToTop();
  return (
    <Layout>
      <h2>
        Definição dos Projetos Apoiados em 2023
      </h2>

      <S.BackText>
        Chegamos ao fim da etapa de formação do/as proponentes!
        Um dia abençoado, clima agradável, espaço incrível e uma turma pra lá de animada foram os destaques de nosso último
        final de semana coletivo. Agora pra definir os projetos aprovados para uso dos recursos do primeiro edital do Programa
        Favela Parque.
      </S.BackText>

      <S.BackText>
        A manhã teve início com exposição de Marcio Ranauro sobre o incrível avanço que cada proponente imprimiu: de uma ideia
        inicial a um projeto descrito em detalhes e a composição de uma “apostila” com 15 projetos e seus elementos.
        Prontos para que cada coletivo siga aplicando para outros editais.
      </S.BackText>

      <S.BackText>
        Charles Siqueira, coordenador do Programa, parabenizou a todo/as e agradeceu a presença de Viviane Lasmar, Chefe do
        Parque Nacional da Tijuca, de Selma Magalhães, que cedeu o espaço do Casarão dos Prazeres e da turma de Psicologia
        da UFRJ, que acompanha a sistematização de nosso Programa.
      </S.BackText>

      <S.BackText>
        Em seguida, cada proponente teve dois minutos para defender sua proposta perante os jurados (os demais proponentes,
        os membros da Equipe Supervisora e a Equipe de Gestão). Terminada esta etapa, os coletivos se espalharam pela área do
        Casarão (e suas belas vistas) e fecharam seus rankings individuais.
      </S.BackText>

      <S.BackText>
        Votos computados pela Coordenação, com acompanhamento de Jaime Vilas (Equipe de Supervisão), chegamos ao ranking final
        que definiu 11 projetos aprovados.
      </S.BackText>

      <S.BackText>
        É sempre triste estabelecer aqueles que ficam sem recursos, mas admirável o fairplay de todos diante dos resultados e
        do legítimo processo que construímos para chegar àquele momento. A Coordenação animou o grupo com a perspectiva de
        encontrarmos maneiras de valorização dos resultados obtidos também por aqueles coletivos, o que seguiremos fazendo em
        sintonia com o Conselho Consultivo Comunitário criado a partir do grupo de WhatsApp com todo/as o/as participantes
        pré-selecionado/as.
      </S.BackText>

      <Photos />

    </Layout>
  );
}

export default DefinitionOfSupportedProjects;
